module.exports = __webpack_public_path__ + "img/rep-carissa-callaway.52ce9087.png";